import { render } from "./BandPostListPage.vue?vue&type=template&id=0b6e1667&scoped=true&ts=true"
import script from "./BandPostListPage.vue?vue&type=script&lang=ts"
export * from "./BandPostListPage.vue?vue&type=script&lang=ts"

import "./BandPostListPage.vue?vue&type=style&index=0&id=0b6e1667&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6e1667"]])

export default __exports__